<script>
import {Bar} from 'vue-chartjs'
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, CategoryScale, LinearScale, BarElement)

export default {
  name: "portfolioCustomerChart.vue",
  components: {Bar},
  props: {
    propChartData: {
      type: Object,
    },
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      chartData: {
        labels: ['Q1', 'Q2', 'Q3', 'Q4'],
        datasets: [
          {
            label: 'A Dataset',
            data: [100],
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(54, 162, 235)',
            ]
          },
          {
            label: 'Another Dataset',
            data: [10, 20],
            backgroundColor: [
              'rgb(230, 200, 100)',
              'rgb(54, 200, 235)',
            ]
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        scales: {
          x: {
            ticks: {
              color: "white",
            },
            stacked: true,
            title: {
              display: true,
              text: 'Acres',
              color: 'white',
              font: {
                size: 18,
              }
            }
          },
          y: {
            ticks: {
              color: "white",
              min: 0
            },
            stacked: true,
          }
        },
        plugins: {
          legend: {
            display: false,
          }
        },
      }
    }
  },

  created() {
    this.chartData = this.propChartData;
  },
}
</script>

<template>
  <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
      :ref="chartId"
  />
</template>
